<template>
<div v-if="!showPreloader" class="mobile-menu" @click="open()" :class="{'activeMobile': active}">
  <div class="lines"></div> 
  <div class="lines"></div> 
  <div class="lines"></div>
</div>
</template>

<script>
import { SET_MOBILE_MENU_ACTIVE } from '@/store/mutations.type'
import { mapGetters } from 'vuex'
export default {
  name: 'MobileMenu',
  data () {
    return {
      active: false
    }
  },

  watch: {
    $route (to, from) {
      this.active = false
      this.$store.commit(SET_MOBILE_MENU_ACTIVE, true )
    }
  },

  methods: {
    open () {
      this.active = !this.active
      this.$store.commit(SET_MOBILE_MENU_ACTIVE, !this.active )
    }
  },
  computed: {
    ...mapGetters(['showPreloader'])
  },  
}
</script>

<style lang="scss">
.activeMobile {
  margin-top: -18px;

  .lines {
  }

  .lines:first-child {
    height: 0;
    transition: all 0s;
  }

  .lines:nth-child(2) {
    top: 63%;
    transform: rotate(45deg);
    position: relative;
  }

  .lines:nth-child(3) {
    top: 40%;
    transform: rotate(-45deg);
    position: relative;

  }
}

.subpage-gray {
  .lines {
    background-color: #5f70b7;
  }
}

.mobile-menu {
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 99999;
  left: 85vw;
  right: 0;
  top: 25px;
  margin-right: 3px;
  display: none;

  .lines {
    width: 30px;
    height: 4px;
    margin: 7px;
    background-color: white;
    border-radius: 5px;
    transition: all 0.4s;
  }

}
</style>
